import React, { useContext } from 'react';

import Toggle from '@atlaskit/toggle';

import { Table } from '@qality/common-components/src/atoms/Table';
import { stopPropagation } from '@qality/common-components/src/lib/util/event';
import { messages } from '@qality/common-messages';
import { QAlitySettingsContext } from '@qality/common-state/src/QAlitySettingsProvider/QAlitySettingsContext';
import { Utils } from '@qality/common-utils';

export const ProjectSettingsRowToggleAll: React.FC = () => {
  const {
    query,
    isAppVisibleInAllIssuesForAllProjects,
    toggleAppVisibilityInAllIssuesForAllProjects,
    isPluginEnabledForAllProjects,
    togglePluginForAllProjects,
    getIsPluginEnabledInAtLeastOneProject,
  } = useContext(QAlitySettingsContext);

  const toggleLabel = Utils.isNilOrEmpty(query)
    ? messages['page.settings.section.enableAll.label']
    : messages['page.settings.section.enableFilteredResults.label'];

  return (
    <Table.Tr isHighlighted data-testid='QAlitySettingsTable.Row-Tr'>
      <Table.Td />
      <Table.Td>
        <Table.ContentHelper alignItems='center'>
          <Toggle
            testId='toggle_plugin_for_all_projects'
            isChecked={isPluginEnabledForAllProjects}
            size='large'
            onChange={togglePluginForAllProjects}
          />
          {toggleLabel}
        </Table.ContentHelper>
      </Table.Td>
      <Table.Td>
        <Table.ContentHelper
          flex='inline-flex'
          alignItems='center'
          muted={!getIsPluginEnabledInAtLeastOneProject()}
          onClick={stopPropagation}
        >
          <Toggle
            testId='toggle_app_visibility_in_all_issues_for_all_projects'
            isChecked={isAppVisibleInAllIssuesForAllProjects}
            isDisabled={!getIsPluginEnabledInAtLeastOneProject()}
            size='large'
            onChange={toggleAppVisibilityInAllIssuesForAllProjects}
          />
          {toggleLabel}
        </Table.ContentHelper>
      </Table.Td>
      <Table.Td />
    </Table.Tr>
  );
};
